<template>
  <div :class="classes" class="parent">
    <p ref="textRef">
      {{ displayText }}
    </p>
  </div>

  <span v-if="isOmitted" class="read-more" @click="toggleExpand()"
    ><template v-if="!isExpanded">. . . 続きを読む</template><template v-else>閉じる</template></span
  >
</template>
<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

interface Props {
  text: string;
  lines: number;
}

const props = defineProps<Props>();

// 表示状態
const isExpanded = ref<boolean>(false);

// テキスト要素の高さ
const textRef = ref<HTMLElement>();

const displayText = computed(() => {
  return props.text;
});

const classes = computed(() => ({ ['expand--true']: isExpanded.value, ['expand--false']: !isExpanded.value }));
const toggleExpand = () => {
  isExpanded.value = !isExpanded.value;
};

// 省略されているかの判定
const isOmitted = computed(() => {
  return lineHeight.value && contentHeight.value && lineHeight.value * props.lines < contentHeight.value;
});

// line-heightの高さ
const lineHeight = computed(() => {
  if (!textRef.value) return;
  return Number(window.getComputedStyle(textRef.value).getPropertyValue('line-height').replace('px', ''));
});

// isExpandedがtrue時の高さ（px）
const contentHeightPx = computed(() => {
  return `${contentHeight.value}px`;
});

// isExpandedがfalse時の高さ（px）
const defaultHeightPx = computed(() => {
  if (isOmitted.value && lineHeight.value) {
    return `${lineHeight.value * props.lines}px`;
  }
  return `${contentHeight.value}px`;
});

const contentHeight = ref<number>();

const resizeContentHeight = () => {
  // テキスト要素のref変数を更新する
  if (textRef.value) contentHeight.value = textRef.value.offsetHeight;
};

onMounted(() => {
  contentHeight.value = textRef.value?.offsetHeight;

  window.addEventListener('resize', resizeContentHeight);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', resizeContentHeight);
});
</script>

<style lang="scss">
.parent {
  overflow: hidden;
}

.expand {
  &--true {
    transition: 0.5s;
    height: v-bind(contentHeightPx); /* stylelint-disable-line value-keyword-case */
  }

  &--false {
    transition: 0.5s;
    height: v-bind(defaultHeightPx); /* stylelint-disable-line value-keyword-case */
  }
}

.read-more {
  display: flex;
  justify-content: flex-end;
  font-size: 14px;
  cursor: pointer;
  margin-top: 10px;
}
</style>
